import React, { useRef } from 'react';

const MentionLink = ({ mention, children, className, mentionStyles }) => (
  <a href={mention.link} className={className} css={mentionStyles} spellCheck={false}>
    {children}
  </a>
);

const MentionText = ({ children, className, mentionStyles, mentionRef, onClick }) => (
  <span
    ref={(element) => mentionRef(element)}
    className={className}
    css={mentionStyles}
    spellCheck={false}
    onClick={onClick}
  >
    {children}
  </span>
);

const Mention = (props) => {
  const {
    entityKey,
    theme = {},
    mentionComponent,
    children,
    decoratedText,
    className,
    contentState,
  } = props;

  const searchPortal = useRef();
  // Note: this is a workaround for an obscure issue: https://github.com/draft-js-plugins/draft-js-plugins/pull/667/files
  // Ideally we can remove this in the future.
  const searchPortalRef = (element) => {
    searchPortal.current = element;
  };

  const updatePortalClientRect = (currentProps) => {
    currentProps.store.updatePortalClientRect(
      currentProps.offsetKey,
      () => searchPortal && searchPortal.current && searchPortal.current.getBoundingClientRect()
    );
  };

  const mentionOnClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    props.store.register(props.offsetKey);
    props.store.setIsOpened(true);
    updatePortalClientRect(props);

    props.store.setIsEdited(true);
    props.store.setSelectedMention(props.decoratedText);

    // trigger a re-render so the MentionSuggestions becomes active
    props.setEditorState(props.getEditorState());
  };

  if (!entityKey) {
    // TODO: only use to render mention entities with format: { field name }
    return (
      <MentionText
        mentionRef={searchPortalRef}
        className={className}
        css={theme.mention}
        spellCheck={false}
        onClick={mentionOnClick}
      >
        {children}
      </MentionText>
    );
  }

  const mention = contentState.getEntity(entityKey).getData().mention;

  const Component = mentionComponent || (mention.link ? MentionLink : MentionText);

  return (
    <Component
      mentionRef={searchPortalRef}
      entityKey={entityKey}
      mention={mention}
      theme={theme}
      className={className}
      mentionStyles={theme.mention}
      decoratedText={decoratedText}
      onClick={mentionOnClick}
    >
      {children}
    </Component>
  );
};

export default Mention;
